var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "_flex _fd-c _fd-r--m _gap-1" },
    _vm._l(_vm.items, function (item) {
      return _c(
        "backing-information-list-item",
        _vm._b(
          {
            key: item.key,
            attrs: { "data-qa": `${item.key}` },
            nativeOn: {
              click: function ($event) {
                return _vm.selectItem(item.key)
              },
            },
          },
          "backing-information-list-item",
          item,
          false
        )
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }